// 答案基础属性配置
import i18n from "@/i18n";

export const answerBaseProp = () => {
    return {
        // 基础服务-生效渠道
        basicServices: [
            {
                label: i18n.t("zhiji.channel.SDKLogin"),
                value: "sdk_login"
            },
            {
                label: i18n.t("zhiji.channel.SDKSet"),
                value: "sdk"
            },
            {
                label: i18n.t("zhiji.channel.m_guest"),
                value: "m_guest"
            },
            {
                label: i18n.t("zhiji.channel.m_setting"),
                value: "m_setting"
            }
        ],
        // 安全助手-生效渠道
        effectChannel: [
            {
                label: i18n.t("zhiji.channel.H5Scenes"),
                value: "h5_block"
            },
            {
                label: i18n.t("zhiji.channel.H5Site"),
                value: "h5_safety"
            }
        ],
        // 内容助手-生效渠道
        contentEffectChannel: [
            {
                label: "Mobile",
                value: "mobile"
            },
            {
                label: "Lite",
                value: "lite"
            }
        ],
        // 内容助手-生效机型
        effectMobileType: [
            {
                label: i18n.t("zhiji.answer.highEnd"),
                value: "178"
            },
            {
                label: i18n.t("zhiji.answer.lowEnd"),
                value: "179"
            }
        ],
        // 对话状态
        dmStatus: [
            {
                label: i18n.t("zhiji.answer.default"),
                value: "default"
            },
            {
                label: i18n.t("zhiji.answer.seal"),
                value: "block"
            }
        ],
        // 循环时间
        cycleData: [
            {
                label: i18n.t("zhiji.answer.monday"),
                value: "21"
            },
            {
                label: i18n.t("zhiji.answer.tuesday"),
                value: "22"
            },
            {
                label: i18n.t("zhiji.answer.wednesday"),
                value: "23"
            },
            {
                label: i18n.t("zhiji.answer.thursday"),
                value: "24"
            },
            {
                label: i18n.t("zhiji.answer.friday"),
                value: "25"
            },
            {
                label: i18n.t("zhiji.answer.saturday"),
                value: "26"
            },
            {
                label: i18n.t("zhiji.answer.sunday"),
                value: "27"
            }
        ],
        // 循环时间段
        cyclePeriod: [
            {
                label: i18n.t("zhiji.answer.morning"),
                value: "31"
            },
            {
                label: i18n.t("zhiji.answer.noon"),
                value: "32"
            },
            {
                label: i18n.t("zhiji.answer.afternoon"),
                value: "33"
            },
            {
                label: i18n.t("zhiji.answer.evening"),
                value: "34"
            },
            {
                label: i18n.t("zhiji.answer.earlyMor"),
                value: "35"
            }
        ],
        // 循环时间所有ID
        cycleTimesId: ["21", "22", "23", "24", "25", "26", "27", "31", "32", "33", "34", "35"],
        effectTimeRadios: [
            {
                label: i18n.t("zhiji.answer.permanent"),
                value: "all",
                checked: true
            },
            {
                label: i18n.t("zhiji.answer.custom"),
                value: "custom",
                checked: false
            }
        ],
        cycleTimeRadios: [
            {
                label: i18n.t("zhiji.answer.allTime"),
                value: "all",
                checked: true
            },
            {
                label: i18n.t("zhiji.answer.custom"),
                value: "custom",
                checked: false
            }
        ],
        answerStatus: [
            {
                label: i18n.t("zhiji.answer.startUp"),
                value: "1",
                checked: true
            },
            {
                label: i18n.t("zhiji.answer.deactivate"),
                value: "0",
                checked: false
            }
        ],
        startTimeConfig: {
            position: "left",
            hasRadius: true,
            dateFormat: "YYYY/MM/DD hh:mm"
        },
        endTimeConfig: {
            position: "right",
            hasRadius: true,
            dateFormat: "YYYY/MM/DD hh:mm"
        }
    };
};
